'use client';

import Quote from '@/components/typography/quote';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';

export default function Hero() {
    const { t } = useTranslation();

    return (
        <div>
            <div className="mb-[2rem] max-w-[1278px] p-4 px-5 text-center lg:mx-auto lg:mb-[9rem] lg:pt-[7rem]">
                <div className="mt-[8rem]">
                    <Quote className="inline pt-[2rem]">
                        {t('hero.text1')}{' '}
                    </Quote>
                    <br className="block lg:hidden" />
                    <Quote variant="italic" className="inline">
                        {t('hero.text2')}
                    </Quote>
                    <Quote className="inline pt-[2rem]">
                        {t('hero.text3')}{' '}
                    </Quote>
                    <Quote variant="italic" className="inline">
                        {t('hero.text4')}
                    </Quote>
                </div>
            </div>
            <Image
                className="mx-auto h-[14.81306rem] max-w-full object-cover lg:h-[42.9375rem]"
                src="/images/bcorp/banner.png"
                alt={t('hero.imageAlt')}
                width={1978}
                height={720}
            />
        </div>
    );
}
